import { ComponentType, createContext } from 'react';

const apiContextDefaults = {
   apiKey: null as string | null,
   apiUrl: null as string | null,
   newApiKey: null as string | null,
   newApiUrl: null as string | null,
   createdUserId: null as string | null,
   squad: null as string | null,
};

const ApiContext = createContext(apiContextDefaults);

export type APIContextProps = {
   apiKey?: string | null;
   apiUrl?: string | null;
   newApiKey?: string | null;
   newApiUrl?: string | null;
   createdUserId?: string | null;
   squad?: string | null;
};

function withApiContext<P>(
   Component: ComponentType<
      Omit<
         P & APIContextProps,
         'apiKey' | 'apiUrl' | 'newApiKey' | 'newApiUrl' | 'createdUserId' | 'squad'
      >
   >
) {
   return function ApiContextProvider({
      apiKey,
      apiUrl,
      newApiKey,
      newApiUrl,
      createdUserId,
      squad,
      ...props
   }: P & APIContextProps) {
      const apiContext = {
         createdUserId,
         apiKey,
         apiUrl,
         newApiKey,
         newApiUrl,
         squad,
      };

      return (
         // @ts-expect-error TS(2322) FIXME: Type '{ createdUserId: string | null | undefined; ... Remove this comment to see the full error message
         <ApiContext.Provider value={apiContext}>
            <Component {...props} />
         </ApiContext.Provider>
      );
   };
}

export { withApiContext, ApiContext };
